const initialState = {
    data: {
        id: null,
        isClosed : false,
    },
};
  
  const currAssessmentReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SET_CURR_ASSESSMENT":        
        return { 
          ...state,
          data: action.payload
        };
      default:
        return state;
    }
  };
  
  export default currAssessmentReducer;
  